import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-layout-control',
    templateUrl: './layout-control.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./layout-control.component.scss']
})
export class LayoutControlComponent {
}
